import { useEffect, useRef } from "react";

/**
 * Cierra automáticamente a los `delay` ms una ventana emergente de COBRO EXITOSO ya validado.
 * - `active`: true SOLO cuando la ventana de éxito está visible (no aplicar a pagos en proceso,
 *   pendientes, rechazados, errores, advertencias ni modales de configuración).
 * - `onDismiss`: acción de cierre existente del modal (no crea ni rediseña modales).
 * El temporizador arranca cuando `active` pasa a true y se cancela si el operador cierra antes.
 */
export function useAutoDismiss(active, onDismiss, delay = 5000) {
  const cb = useRef(onDismiss);
  cb.current = onDismiss;
  useEffect(() => {
    if (!active) return undefined;
    const t = setTimeout(() => { if (cb.current) cb.current(); }, delay);
    return () => clearTimeout(t);
  }, [active, delay]);
}
